import { render, staticRenderFns } from "./admin-kyc-verification.vue?vue&type=template&id=8d7330e6&"
import script from "./admin-kyc-verification.vue?vue&type=script&lang=js&"
export * from "./admin-kyc-verification.vue?vue&type=script&lang=js&"
import style0 from "./admin-kyc-verification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports